<template>
    <div :class="[has_error==='1' ? 'has-error' : '','form-group']" :id="'date_'+id">
        <label>{{ name }}</label>
        <div class="input-group date">
            <datepicker v-model="v_from"
                        :max="v_to"
                        hide-icon
                        popup-used-in-modal
            />
            <span class="input-group-addon">{{ t_to }}</span>
            <datepicker v-model="v_to"
                        :min="v_from"
                        hide-icon
                        popup-used-in-modal />

        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value', 'has_error'],
        data: function() {
            return {
                t_to: Lang.langGet("to"),
            }
        },
        computed: {
            v_from: {
                get() {
                    return this.value.split(':')[0] || '';
                },
                set(val) {
                    this.$emit('input', `${val}:${this.v_to}`);
                }
            },
            v_to: {
                get() {
                    return this.value.split(':')[1] || '';
                },
                set(val) {
                    this.$emit('input', `${this.v_from}:${val}`);
                }
            }
        },
    }
</script>
